import { render, staticRenderFns } from "./DadosTreinador.vue?vue&type=template&id=23d494c3&"
import script from "./DadosTreinador.vue?vue&type=script&lang=js&"
export * from "./DadosTreinador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports